/**
 * @generated SignedSource<<b7147eda4cf050e15333cef08fa2b251>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RegionEditCitiesRefetchQuery$variables = {
  after?: string | null;
  first: number;
  id: string;
  search?: string | null;
};
export type RegionEditCitiesRefetchQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"RegionEditCities_region">;
  } | null;
};
export type RegionEditCitiesRefetchQuery = {
  response: RegionEditCitiesRefetchQuery$data;
  variables: RegionEditCitiesRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "search"
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "RegionEditCitiesRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RegionEditCities_region"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "RegionEditCitiesRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v5/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "after",
                    "variableName": "after"
                  },
                  {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                  },
                  {
                    "kind": "Variable",
                    "name": "search",
                    "variableName": "search"
                  }
                ],
                "concreteType": "CityConnection",
                "kind": "LinkedField",
                "name": "cities",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CityEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "City",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "deletable",
                                "storageKey": null
                              }
                            ],
                            "type": "Entity",
                            "abstractKey": "__isEntity"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "total",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__id",
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Region",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0afd41ce1741048894aebdee8b34f35f",
    "id": null,
    "metadata": {},
    "name": "RegionEditCitiesRefetchQuery",
    "operationKind": "query",
    "text": "query RegionEditCitiesRefetchQuery(\n  $after: String\n  $first: Int!\n  $search: String\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...RegionEditCities_region\n    id\n  }\n}\n\nfragment AddCityDialog_region on Region {\n  id\n}\n\nfragment CityRow_city on City {\n  id\n  name\n  ...EntityTableRow_entity\n}\n\nfragment EntityTableRow_entity on Entity {\n  __isEntity: __typename\n  id\n  deletable\n}\n\nfragment RegionEditCities_region on Region {\n  cities(first: $first, after: $after, search: $search) {\n    edges {\n      node {\n        id\n        ...CityRow_city\n      }\n    }\n    pageInfo {\n      ...Table_pageInfo\n    }\n  }\n  ...AddCityDialog_region\n  id\n}\n\nfragment TablePagination_pageInfo on PageInfo {\n  total\n}\n\nfragment Table_pageInfo on PageInfo {\n  total\n  ...TablePagination_pageInfo\n}\n"
  }
};
})();

(node as any).hash = "41842d69b5cd846e2c3407815138583b";

export default node;
